import carouselVariables from './carouselVariables';

export default carouselVariables;
